module.exports = __webpack_public_path__ + "img/blog4.9368b832.png";